import { c as _c } from "react/compiler-runtime";
import { mediaSrc } from "@/data/archivalEventsData";

/** Card thumbnail — image only, edge-to-edge in container */
export default function EventCardMedia(t0) {
  const $ = _c(9);
  const {
    event,
    className: t1
  } = t0;
  const className = t1 === undefined ? "" : t1;
  if (!event?.image) {
    return null;
  }
  let t2;
  if ($[0] !== event.image) {
    t2 = mediaSrc(event.image);
    $[0] = event.image;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = event.imageAlt || event.title;
  const t4 = `w-full h-full object-cover block ${className}`;
  let t5;
  if ($[2] !== event.imagePosition) {
    t5 = event.imagePosition ? {
      objectPosition: event.imagePosition
    } : undefined;
    $[2] = event.imagePosition;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  let t6;
  if ($[4] !== t2 || $[5] !== t3 || $[6] !== t4 || $[7] !== t5) {
    t6 = <img src={t2} alt={t3} className={t4} style={t5} />;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}